/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Public API for Zone
export { NgZone } from "./zone/ng_zone";
//# sourceMappingURL=zone.js.map


// WEBPACK FOOTER //
// ../../../packages/core/esm5/src/zone.js